var map = {
	"./InB.png": "./app/packs/images/InB.png",
	"./KT.png": "./app/packs/images/KT.png",
	"./Pop_Up_Icon.png": "./app/packs/images/Pop_Up_Icon.png",
	"./SJT.png": "./app/packs/images/SJT.png",
	"./ai.png": "./app/packs/images/ai.png",
	"./bg-3.jpg": "./app/packs/images/bg-3.jpg",
	"./comviva_logo.png": "./app/packs/images/comviva_logo.png",
	"./dcpl.png": "./app/packs/images/dcpl.png",
	"./header-bg.jpeg": "./app/packs/images/header-bg.jpeg",
	"./naman_logo.png": "./app/packs/images/naman_logo.png",
	"./organogram.png": "./app/packs/images/organogram.png",
	"./rp.png": "./app/packs/images/rp.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/packs/images sync recursive ^\\.\\/.*$";